/* eslint-disable prettier/prettier */
import React, { FC, useState } from 'react';
import ModalidadForm from '../../Tarjetas/commons/ModalidadForm';
import CalculadoraForm from '../../Tarjetas/commons/CalculadoraForm';
import CambioCuentaForm from './form/CambioCuentaForm';
// import { useTranslation } from 'react-i18next';
// import useAPIError from '../../hooks/useAPIError';
// import { useAuthStore } from '../../store/AuthContext';
// import { useAppStore } from '../../store/AppContext';
import tarjetaOro from '../../../assets/images/tarjeta-oro.png';
import IconPencil from '../../../Icons/IconPencil';

const TarjetaOroDatosCaprabo: FC = () => {
  // const { t } = useTranslation();
  // const dataUser = useAuthStore();
  // const dataApp = useAppStore();
  // const { addError, addErrorBack } = useAPIError();
  const [showFormModalidad, setShowFormModalidad] = useState<boolean>(false);
  const [showFormCuentaBank, setShowFormCuentaBank] = useState<boolean>(false);
  const [showFormCalculadora, setShowFormCalculadora] = useState<boolean>(
    false,
  );
  // useEffect(() => {
  //   if (dataUser.user.token !== '') retrieveSaldo();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [i18n.language]);
  return (
    <>
      <section className="section header-tarjetas header-tarjetas__large tarjetas">
        <div className="container-inner">
          <div className="header-tarjetas__content">
            <h1 className="header-tarjetas__title">Tarjeta Oro</h1>
            <p>
              Tu número de socio Eroski Club <strong>6015432345</strong>
            </p>
          </div>
        </div>
      </section>
      <section className="o-section u-padding-top-hero u-padding-bottom-hero section--background-img tarjetas">
        <div className="container-inner">
          <div className="img-tarjeta img-tarjeta__oro">
            <img src="../assets/images/tarjeta-oro.png" alt="Tarjeta Oro" />
          </div>
          <div className="tarjeta__content tarjeta-oro__content">
            <h2 className="bloque-datos__title">
              <span className="divider__square brand-gold-color" />
              <span className="u-margin-right">Datos de la Tarjeta Oro</span>
            </h2>
          </div>

          <div className="bloque-datos">
            <div className="bloque-datos__datos u-margin-bottom-medium">
              <h3 className="bloque-datos__name bloque-datos__title">
                <span className="u-margin-right">
                  Modalidad de ahorro actual
                </span>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <a
                  className="bloque-datos__action modalidad"
                  onClick={() => setShowFormModalidad(true)}
                >
                  <span className="hidden">Enlace a la edicion del bloque</span>
                  <span className="icon__stroke icon-round icon-gold">
                    <IconPencil />
                  </span>
                </a>
              </h3>
              <p>4% - 4,99€ cuota mes</p>
            </div>

            <div className="bloque-datos__datos u-margin-bottom-medium">
              <h3 className="bloque-datos__name bloque-datos__title">
                <span className="u-margin-right">Cuenta Bancaria</span>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <a
                  className="bloque-datos__action edit-iban"
                  onClick={() => setShowFormCuentaBank(true)}
                >
                  <span className="hidden">Enlace a la edicion del bloque</span>
                  <span className="icon__stroke icon-round icon-gold">
                    <IconPencil />
                  </span>
                </a>
              </h3>
              <p>ES 451474 641274 31245678</p>
            </div>

            <div className="bloque-datos__datos u-margin-bottom-medium">
              <h3 className="bloque-datos__name bloque-datos__title">
                <span className="u-margin-right">
                  Fecha de alta de la tarjeta
                </span>
              </h3>
              <p>20/04/2010</p>
            </div>

            <div className="bloque-datos__datos u-margin-bottom-medium">
              <h3 className="bloque-datos__name bloque-datos__title">
                <span className="u-margin-right">Próxima cuota</span>
              </h3>
              <p>Enero 2020</p>
            </div>

            <div className="bloque-datos__datos u-margin-bottom-medium">
              <h3 className="bloque-datos__name bloque-datos__title">
                <span className="u-margin-right">Estado</span>
              </h3>
              <p>Activo</p>
            </div>

            <div className="bloque-datos__datos u-margin-bottom-medium">
              <h3 className="bloque-datos__name bloque-datos__title">
                <span className="u-margin-right">¿Quieres darte de baja?</span>
              </h3>
              <p>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="link link-oro">Solicitar baja</a>
              </p>
            </div>
          </div>

          <div className="bloque-action__tarjeta-second bloque-action__second">
            <div className="img img-tarjeta_small">
              <img src={tarjetaOro} alt="Tarjeta Oro" />
            </div>
            <p className="bloque-action__title">
              ¿Estás pensando cambiar de cuota?
            </p>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <a
              className="btn btn-oro calcular"
              onClick={() => setShowFormCalculadora(true)}
            >
              Calcular tu ahorro
            </a>
          </div>
        </div>
      </section>
      <section className="o-section--large tarjetas">
        <div className="container-inner">
          <div className="tarjeta__content tarjeta-oro__content">
            <h2 className="bloque-datos__title">
              <span className="divider__square brand-gold-color" />
              <span className="u-margin-right u-text-oro">
                Cuotas pendientes
              </span>
            </h2>
          </div>
          <div className="table-responsive u-margin-bottom-large">
            <table className="table table--striped">
              <thead>
                <tr>
                  <th>
                    <span>Concepto</span>
                  </th>
                  <th className="num">Importe</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>
                      Recibo cuota 2017 enero.{' '}
                      <strong>Pendiente de pago</strong>
                    </span>
                  </td>
                  <td className="num">
                    <span>4,77</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>
                      Recibo cuota 2017 enero.{' '}
                      <strong>Pendiente de pago</strong>
                    </span>
                  </td>
                  <td className="num">
                    <span>4,77</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <span className="u-font-bold">Total</span>
                  </td>
                  <td className="num">
                    <span>9,66</span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <p className="u-margin-bottom">
            Si lo deseas, puedes pagar tus cuotas pendientes con el servicio de
            Compra Electrónica Segura.
          </p>

          <p>
            Lo tienes activado?,{' '}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="link link-oro">más información</a>
          </p>

          <form method="post" className="u-margin-top-large">
            <fieldset className="u-margin-bottom-medium">
              <legend className="hidden">
                ¿Necesitas otra tarjeta para ti o familiar?
              </legend>
              <ul className="u-margin-bottom-medium">
                <li className="u-margin-bottom">
                  <div className="radio radio-inline radio__oro">
                    <input
                      type="radio"
                      id="estropeada"
                      value="estropeada"
                      name="necesitastarjeta"
                      className="form-control"
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="estropeada" className="control-label">
                      Si, lo tengo activado
                    </label>
                  </div>
                </li>
                <li className="u-margin-bottom">
                  <div className="radio radio-inline radio__oro">
                    <input
                      type="radio"
                      value="familia"
                      id="familia"
                      name="necesitastarjeta"
                      className="form-control"
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="familia" className="control-label">
                      No, aún no lo tengo activaco
                    </label>
                  </div>
                </li>
              </ul>
            </fieldset>
            <p className="u-text-right">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="" className="btn btn-oro">
                Abonar cuotas pendientes
              </a>
            </p>
          </form>
        </div>
      </section>
      {/* Cambio modalidad */}
      <ModalidadForm
        visible={showFormModalidad}
        setVisible={setShowFormModalidad}
        cuotaAltaSelected
      />
      {/* calculadora */}
      <CalculadoraForm
        visible={showFormCalculadora}
        setVisible={setShowFormCalculadora}
      />
      {/* Cambio cuenta */}
      <CambioCuentaForm
        visible={showFormCuentaBank}
        setVisible={setShowFormCuentaBank}
      />{' '}
    </>
  );
};

export default TarjetaOroDatosCaprabo;
